import { ForgotPassword } from 'components/containers';

export default function ForgotPasswordPage() {
  return <ForgotPassword />;
}
